<template>
  <div class="content d-flex flex-column mt-2">
    <div class="d-flex row mx-2 mb-2 align-items-center">
      <div class="header col">
      </div>
      <div class="actions col-auto">
        <button 
          class="py-4 px-5 rounded" 
          :style="buttonStyle" 
          @click="$emit('add-project')"
          :disabled="!canEdit"
        >
          + Adicionar projeto
        </button>
      </div>
    </div>
    <div class="section border rounded">
      <v-data-table
        :headers="headers"
        :items="projetos"
        disable-pagination
        no-data-text="Nenhum projeto encontrado neste agrupamento."
      >
        <template v-slot:item.trabalho="{ item }">
          {{ getBeneficioLabel(item.trabalho) }}
        </template>
        <template v-slot:item.status="{ item }">
          {{ getStatusLabel(item.status) }}
        </template>
        <template v-slot:item.data_inicio="{ item }">
          {{ formatDate(item.data_inicio) }}
        </template>
        <template v-slot:item.data_fim="{ item }">
          {{ formatDate(item.data_fim) }}
        </template>
         <template v-slot:item.actions="{ item }">
          <v-btn
            icon
            small
            @click="openProject(item)"
            title="Ver projeto"
          >
            <v-icon>mdi-eye</v-icon>
          </v-btn>
          <v-btn
            icon
            small
            @click="$emit('remove-project', item)"
            title="Remover do agrupamento"
            class="ml-2"
            :disabled="!canEdit"
          >
            <v-icon color="error" :style="!canEdit ? 'color: grey !important' : ''">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { BeneficiosLabels } from "@/core/enums/beneficios";
// import { StatusProjetoEnum } from "@/core/enums/projetos";
import moment from "moment";
import { mapGetters } from "vuex";
import { UserTypeEnum } from "@/core/enums/user-types";

export default {
  name: "AgrupamentoProjectsList",
  props: {
    projetos: {
      type: Array,
      required: true,
      default: () => [],
    },
    statusOpts: {
        type: Array,
        default: () => []
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: "ID", value: "id_projeto" },
        { text: "Título", value: "titulo" },
        { text: "Benefício", value: "trabalho" },
        { text: "Status", value: "status" },
        { text: "Ano-base", value: "ano_base" },
        { text: "Data início", value: "data_inicio" },
        { text: "Data fim", value: "data_fim" },
        { text: "Ações", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["user"]),
    buttonStyle() {
      if (!this.canEdit) {
        return {
          backgroundColor: '#e0e0e0',
          color: '#a0a0a0',
          fontWeight: 'bold',
          cursor: 'not-allowed'
        };
      }
      const user = this.user || {};
      const { tipo_usuario } = user;
      const isClient = [UserTypeEnum.GERENCIAL_CLIENTE, UserTypeEnum.COLABORADOR].includes(tipo_usuario);
      const color = isClient ? 'rgba(11, 84, 86, 0.9)' : '#1c1c44';
      return {
        backgroundColor: color,
        fontWeight: 'bold',
        color: 'white'
      };
    }
  },
  methods: {
    getBeneficioLabel(valor) {
      return BeneficiosLabels[valor] || "Desconhecido";
    },
    getStatusLabel(valor) {
        if (this.statusOpts.length) {
            const status = this.statusOpts.find(s => s.id === valor);
            return status ? status.label : valor;
        }
        return valor;
    },
    formatDate(date) {
        if (!date) return '-';
        return moment(date).format('DD/MM/YYYY');
    },
    openProject(item) {
        // Navigate to the project analysis page
        const route = this.$router.resolve({
            name: "ficha-projeto-analise",
            params: { projetoId: item.id },
        });
        window.open(route.href, "_blank");
    }
  },
};
</script>

<style scoped>
.agrupamento-projects-list {
  /* padding removed as requested */
}
</style>
